import { Component, EventEmitter, Input, Output, OnChanges } from '@angular/core';

interface AzPill {
  letter: string;
  count: number;
  empty: boolean;
}

const ALPHABET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
const UK_PLATE_BANNED = new Set(['I', 'Q', 'Z']);

@Component({
  selector: 'pla-new-release-az-pills',
  templateUrl: './new-release-az-pills.component.html',
  styleUrls: ['./new-release-az-pills.component.scss'],
})
export class NewReleaseAzPillsComponent implements OnChanges {
  @Input() azCounts: Record<string, number> = {};
  /** Currently-selected letter (or null for "show all"). Highlights the matching pill. */
  @Input() activeLetter: string | null = null;
  /** Hide letters that never appear on UK plates (I, Q, Z). Defaults to true. */
  @Input() hideBannedLetters: boolean = true;
  @Output() letterClicked = new EventEmitter<string | null>();

  pills: AzPill[] = [];

  ngOnChanges(): void {
    this.pills = ALPHABET
      .filter((l) => !this.hideBannedLetters || !UK_PLATE_BANNED.has(l))
      .map((letter) => {
        const count = this.azCounts[letter] || 0;
        return { letter, count, empty: count === 0 };
      });
  }

  onClick(pill: AzPill): void {
    if (pill.empty) return;
    // Click the already-active letter to clear the filter.
    if (this.activeLetter === pill.letter) {
      this.letterClicked.emit(null);
      return;
    }
    this.letterClicked.emit(pill.letter);
  }

  onAllClick(): void {
    if (this.activeLetter === null) return;
    this.letterClicked.emit(null);
  }
}
